import { Container, Row, Col } from "react-bootstrap";
import aboutLogo from "../../Assets/devanshi.png";
import About2 from "./About2";
import Box from '@mui/material/Box';
import Button from "react-bootstrap/Button";
import './About.css'
import { Link } from "react-router-dom";
import Navbar from "../Navbar";
import Footer from "../Footer";

function About() {
  function handleScroll() {
    window.scroll({
      top: document.body.offsetHeight,
      left: 0, 
      behavior: 'smooth',
    });
  }
  return (

    <section>
      <Navbar />
      <Box className="filebox" sx={{ border: '2px solid white', borderRadius: '15px', width: '100%' }}>
        <Row>
          <aside>
          <Col sm={1}>
            <Container>
            {/* <p className="txt">ABOUT ME - DEVANSHI JHAVERI</p> */}
            
            <div direction="right" className="side-banner">
            <div className="marquee">
              <div className="marquee-content">
                ABOUT ME - DEVANSHI JHAVERI          ABOUT ME - DEVANSHI JHAVERI          ABOUT ME - DEVANSHI JHAVERI          ABOUT ME - DEVANSHI JHAVERI          ABOUT ME - DEVANSHI JHAVERI          ABOUT ME - DEVANSHI JHAVERI          ABOUT ME - DEVANSHI JHAVERI          ABOUT ME - DEVANSHI JHAVERI          ABOUT ME - DEVANSHI JHAVERI
                </div>
            </div>
            </div>
            </Container>
          </Col>
          <Col sm={11}>
            <Container className="about-section" id="about">
              <Container className="about-content">
                <Row>
                  <Col md={4}>
                    <img src={aboutLogo}
                      alt="about pic"
                      className="img-fluid myphoto"
                      
                    />
                  </Col>

                  <Col md={7} className="about-header">
                    <h1 className="heading">
                      Hi, I am <text style={{color:'#F9D63D'}}>Devanshi Jhaveri!</text>{" "}

                    </h1>

                    <p className="content">
                    A <b className="bold-content"><i>product designer</i></b> fond of learning new things, from crafting intuitive user experiences to exploring state-of-the-art technologies. Nothing excites me more than the challenge of designing products that seamlessly blend form and function while delighting users and generating maximum engagement.
                    </p>
                    {/* <Link to="/contact" style={{textDecoration: 'none'}}> */}
                    {/* <a href="www.google.com"> */}
                    <Button className="about-button box-p" onClick={handleScroll}>  Lets connect </Button>
                    
                    {/* </a> */}
                    {/* </Link> */}
                  </Col>


                </Row>
                
              </Container>
            </Container>
            <About2 />
          </Col>
          </aside>
        </Row>
      <Footer id="footer1" />

      </Box>

    </section>

  );
}


export default About;
